import { call, put, takeLatest } from "redux-saga/effects";
import {
  forgotPasswordApi,
  loginApi,
  googleSocialSignApi,
  registerDeviceApi,
} from "../Effects/AuthEffect";
import {
  GOOGLE_SIGN_IN_FAILURE,
  GOOGLE_SIGN_IN_REQUEST,
  GOOGLE_SIGN_IN_SUCCESS,
  LOGIN_FAILURE,
} from "../types/AuthTypes";
import { googleSignInSuccess } from "../actions/authActions";

function* handleLogin(action) {
  try {
    const user = yield call(loginApi, action.payload);

    if (
      !user ||
      !user.accessToken ||
      !user.refreshToken ||
      !user.user ||
      !user.user.email
    ) {
      throw user;
    }
    const permissions = JSON.parse(user.user.access);

    yield put({
      type: "LOGIN_SUCCESS",
      payload: {
        accessToken: user.accessToken,
        refreshToken: user.refreshToken,

        user: {
          id: user.user.id,
          role: user.user.user_type_role_name,
          role_name: user.user.role_name,
          email: user.user.email,
          first_name: user.user.first_name,
          last_name: user.user.last_name,
          contact: user.user.phone,
          id: user.user.user_id,
          customer_id: user.user.customer_id,
          vendor_id: user.user.vendor_id,
          staff_id: user.user.staff_id,
          user_type: user.user.user_type,
          login_status: user.login_status,
          permissions,
        },
      },
    });
  } catch (error) {
    yield put({ type: "LOGIN_FAILURE", payload: error.message });
  }
}

function* handleGoogleSignIn(action) {
  try {
    const response = yield call(googleSocialSignApi, action.payload);

    if (
      !response ||
      !response.accessToken ||
      !response.refreshToken ||
      !response.user ||
      !response.user.email
    ) {
      throw new Error("Invalid response from server");
    }

    const permissions = response.user.access
      ? JSON.parse(response.user.access)
      : null;

    yield put({
      type: "LOGIN_SUCCESS",
      payload: {
        accessToken: response.accessToken,
        refreshToken: response.refreshToken,
        user: {
          id: response.user.user_id,
          role: response.user.user_type_role_name,
          role_name: response.user.role_name,
          email: response.user.email,
          first_name: response.user.first_name,
          last_name: response.user.last_name,
          contact: response.user.phone,
          user_id: response.user.user_id,
          customer_id: response.user.customer_id,
          vendor_id: response.user.vendor_id,
          staff_id: response.user.staff_id,
          user_type: response.user.user_type,
          login_status: response.login_status,
          permissions,
        },
      },
    });
  } catch (error) {
    yield put({ type: LOGIN_FAILURE, payload: error.message });
  }
}

function* handleForgotPassword(action) {
  try {
    const response = yield call(forgotPasswordApi, action.payload.email);
    yield put({
      type: "FORGOT_PASSWORD_SUCCESS",
      payload: response.message || "Reset link sent successfully",
    });
  } catch (error) {
    yield put({
      type: "FORGOT_PASSWORD_FAILURE",
      payload: error.message || "Failed to send reset link",
    });
  }
}
function* handleLogout() {
  try {
    // Clear sessionStorage
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("refreshToken");
    sessionStorage.removeItem("newBookingAccessToken");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("booking_form");

    // Broadcast logout to other tabs
    localStorage.setItem("logoutEvent", Date.now().toString());

    yield put({ type: "LOGOUT_SUCCESS" });
  } catch (error) {
    yield put({ type: "LOGOUT_FAILURE", payload: error.message });
  }
}

export function* watchLogout() {
  yield takeLatest("LOGOUT_REQUEST", handleLogout);
}

export function* watchForgotPassword() {
  yield takeLatest("FORGOT_PASSWORD_REQUEST", handleForgotPassword);
}
export function* watchLogin() {
  yield takeLatest("LOGIN_REQUEST", handleLogin);
}

export function* watchGoogleSignIn() {
  yield takeLatest(GOOGLE_SIGN_IN_REQUEST, handleGoogleSignIn);
}
